/**
 * The page a data download link opens, signed in or not. The API emails it under the site's base
 * URL with the link's token in the fragment, which the browser never sends to a server.
 */
export const dataDownloadPath = '/site-management/data-download'

/** The API's check of a data download link: the token in the body says until when it works. */
export const dataDownloadLinkApi = '/site-management/v1/data-exports/link'

/** The API's download of the data a link is for, as one zip: the token in the body. */
export const dataDownloadFileApi = '/site-management/v1/data-exports/file'
